/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Order } from '@castlery/types';

/**
 * the payload of the API "add to cart"
 */
interface BundleOptions {
  bundle_option_id: number;
  bundle_option_variant_id: number;
}
interface CustomizeOptions {
  product_id: number;
  customizations: {
    // variant_option_values
    option_id: number;
    value_id: number;
  };
}
/**
 * The payload of "Add To Cart" request
 * @options
 * @condition1 If the added items contains bundle items,BundleOptions is required .
 * @condition2 If the added items contains customized items ,CustomizeOptions is required .
 * @condition3 BundleOptions and CustomizeOptions can exist simultaneously .
 */
export interface ATCApiPayload extends Pick<Order, 'number'> {
  variant_id?: number;
  quantity: number; //在加车时, required，在添加service时，optional
  options?: {
    //在加车时，options required，在添加service时，optional
    preferred_self_collection: boolean;
    preferred_stock_location_id?: number;
    warranty_offer_id?: number;
  };
  // TODO 要在这里处理bundle的加车问题
  // & (BundleOptions | CustomizeOptions | (BundleOptions & CustomizeOptions) | never);
}

export enum AdjustmentType {
  'fixed_amount' = 'fixed_amount',
  'percentage' = 'percentage',
}
/**
 * The payload of "Adjust Price" request
 * @orderNumber
 * @lineItemId
 * @adjustment {number} the amount of adjustment
 * @type {AdjustmentType} the type of adjustment, `fixed_amount` or `percentage`
 */
export interface AdjustPriceApiPayload {
  orderNumber: string;
  lineItemId: number;
  adjustment: number;
  type: keyof typeof AdjustmentType;
}

/**
 * The payload of "Change Item Quantity" request
 * @orderNumber {string}
 * @lineItemId {number}
 * @quantity {number}
 * @options {warranty_offer_id?:number} the warranty offer id
 */
export interface ChangeItemQuantityApiPayload {
  orderNumber: string;
  lineItemId: number;
  quantity: number;
  options: {
    warranty_offer_id?: string;
  };
}

/**
 * The payload of "Remove Line Item" request
 * @orderNumber {string}
 * @lineItemId {number}
 */
export interface RemoveLineItemApiPayload {
  orderNumber: string;
  lineItemId: number;
}

export interface OrderTransferApiPayload extends Pick<Order, 'number'> {
  itemIds: number[];
}

export interface ApplyCouponApiPayload extends Pick<Order, 'number'> {
  couponCode: string;
}
